import { ListViewItemWrapper } from "@progress/kendo-react-listview";

/**
 * A single list component that wraps Kendo's ListViewItemWrapper component.
 * This component is used to create list items with various styles.
 * 
 * @component
 * @param {Object} props - properties passed to component.
 * @param {string} props.children - internal items to render within list item.
 * @param {string} props.className - additional CSS classes to apply to list item.
 * @param {string} props.style - inline styles to apply to list item.
 * @returns {JSX.Element}
 * 
 * @see {@link https://www.telerik.com/kendo-react-ui/components/listview | KendoReact ListView Documentation}
 * 
 */
export const ListItem = ({
  className = '',
  style = {},
  children
}) => {
  return (
    <ListViewItemWrapper
      className={className}
      style={style}
    >
      {children}
    </ListViewItemWrapper>
  );
}